module.exports = __webpack_public_path__ + "img/slide1-1.78e68305.png";